import { apiCall } from "@/shared/services/apiCall";
import { errorToast, successToast, helper } from "@/shared/services/helper";
import store  from "@/store/index";

const getWalletAuth = async () => {
    try{
        store.dispatch('setGlobalLoader', true);
        let config = null

        let response = await apiCall('get','GET_WALLET_CONFIG', null, 'wallet')
        store.dispatch('setGlobalLoader', false);
        if (response && response.status == 200) {
            if (response?.data?.error) {
                errorToast(response.data.error);
            }else{
                config = response.data.data

                const defaults = ['100', '200', '500', '1000'];
                let stake_button = store.getters.userTransactionStakes || (config.stake_button?.every(x => Number(x) === 0) ? defaults : config.stake_button || defaults);
                config.stake_button = stake_button;
                store.dispatch('setUserTransactionStakes', stake_button);
            } 
            return { data: config};
        }
    }catch(error){
        store.dispatch('setGlobalLoader', false);
        if (error) {
            errorToast(error);
        }
    }
};

const setWalletStakeValue = (stake, depositAmount, walletConfig) => {
     try {
        depositAmount = parseFloat(depositAmount) || 0;
        stake = parseFloat(stake) || 0;

        depositAmount += stake;
        if(depositAmount > walletConfig?.deposit_range?.max){
            depositAmount = walletConfig?.deposit_range?.max;
        }
        return depositAmount
    } catch (e) {
        errorToast(e)
    }
}

export {
    getWalletAuth,
    setWalletStakeValue
}